import React  from 'react'
import { Grid, Paper, Typography, Divider,Link } from '@material-ui/core';
import CodeBase from './codeComponent';
import { ArrowLeft, ArrowRight } from '@material-ui/icons';

class BasicReactExample extends React.Component{
    constructor(props){
        super(props);
        window.addEventListener('resize',this.update)
        this.state={
            update:false,
        }

    }
    update=()=>{this.setState({update:(!this.state.update)});}
    normalView=()=>{
        let className=(window.screen.width<=768)?'textDescriptionMobile':'textDescription'
        return<Grid container justify='center'>
                <Grid item md={10} lg={10}>
                    <Paper style={{padding:'20px',margin:'20px',paddingLeft: '100px',paddingRight: '100px'}}>
                        <Typography  className='textTitle' variant='h4' >Counter example using Reactjs</Typography>
                        <Divider/>
            
                        <Typography className={className}>
                            In this section we will see how to make use of Actumjs to create a simple counter app with Reactjs.
                            <br/>
                            First , we need to create a new Reactjs app.
                            This can be done by using create-react-app.
                        </Typography>
                        <CodeBase lines={["$ npx create-react-app counter_app"]}/>
                        <Typography className={className}>
                        After that we need to install Actumjs to our project.
                        </Typography>
                        <CodeBase
                        lines={["$ npm install  @actumjs/actum"]}
                        />
                        <Typography className={className}>
                        Now we will describe our application state as store in src/store/index.js file
                        </Typography>
                        <CodeBase
             lang='js'
                 lines={[`
    import {createStore} from '@actumjs/actum';
    const initialState = {count:0};
    const store = createStore(initialState);
    export default store;`
                    ]}
                 />
              <Typography className={className}>
               To manipulate data within store we need to define actions 
               that modity the store in seperate file  `src\actions\index.js`
               
             </Typography>
             <CodeBase
             lang='js'
                 lines={[
                     `
    //an action to increment counter value
    export function increment(payload,state){
        state.count++;
    }
    //an action to decrement counter value
    export function   decrement(payload,state){
        state.count--;
    }
                     `
                    ]}
                 />
                 <Typography className={className}>
                    All actions are required to be added into store to update it.
                    After adding actions to store our src/store/index.js file will look something like this
                 </Typography>
                 <CodeBase
             lang='js'
                 lines={[
                     `
    import {createStore} from '@actumjs/actum';
    import {increment,decrement} from '../actions'\n
    const initialState = {count:0};
    const store = createStore(initialState);\n
    //adding actions to store
    store.addAction("increment",increment);
    store.addAction("decrement",decrement);\n
    export default store;`
                   ]}
                 />
                  <Typography className={className}>
                      Now our store is defined and actions are added to it,further we need to create our counter component in ./src/components/CounterComponent.js,
                      which will display counter value from store and two buttons to increase and decrease counter value
                 </Typography>
                 <CodeBase
             lang='js'
                 lines={[
                     `
    import React from 'react';
    import store from '../store';

    class CounterComponent extends React.Component{
        constructor(props){
            super(props);
        }

    render(){

        let counter = store.getState().count;

        return <div>
                counter : {counter}
                <button>increase</button>
                <button>decrease</button>
            </div>
        }
    }

    export default CounterComponent;
`
                    ]}
                 />
                  <Typography className={className}>
                      Inorder to trigger an action we need to handle click events of buttons.
                 </Typography>
                 <CodeBase
             lang='js'
                 lines={[
                     `
    import React from 'react';
    import store from '../store';

    class CounterComponent extends React.Component{
        constructor(props){
            super(props);
        }

    render(){

        let counter = store.getState().count;

        return <div>

                counter : {counter}
                <button onClick={()=>{store.trigger("increment");}} >increase</button>
                <button onClick={()=>{store.trigger("decrement");}} >decrease</button>
            </div>
        }
    }

    export default CounterComponent;
`
                    ]}
                 />
                  <Typography className={className}>
                    Now we need to reflect changes to component,to do this we need  to listen  actions and update the components.
                    This can be done by adding listners to store actions and updating component state whenever listner called.
                  </Typography>
                 <CodeBase
             lang='js'
                 lines={[
                     `
    import React from 'react';
    import store from '../store';

    class CounterComponent extends React.Component{
        constructor(props){
            super(props);
            this.state={
                update:false
            }
            
            this.RemoveIncrementListener=null;
            this.RemoveDecrementListener=null;
        }

        componentDidMount(){
            //add listeners 
            this.RemoveIncrementListener=store.after("increment",this.update);
            this.RemoveDecrementListener=store.after("decrement",this.update);
        }

        componentWillUnmount(){
            //remove all listeners to store
            this.RemoveIncrementListener();
            this.RemoveDecrementListener();
        }

        //this will cause re-render of component
        update=()=>{this.setState({update:(!this.state.update)})}

        render(){

        let counter = store.getState().count;

        return <div>

                counter : {counter}
                <button onClick={()=>{store.trigger("increment");}} >increase</button>
                <button onClick={()=>{store.trigger("decrement");}} >decrease</button>
            </div>
        }
    }

    export default CounterComponent;
`
                    ]}
                 />
                <Grid container justify='space-between' style={{paddingBottom:'50px'}}>
                    <Grid item >
                        <Link href="/examples">
                            <ArrowLeft/>back to examples
                        </Link>
                    </Grid>
                </Grid>
                    </Paper>
                </Grid>
            </Grid>
        }
    mobileView=()=>{
        let className=(window.screen.width<=768)?'textDescriptionMobile':'textDescription'
        return<Grid container justify='center'>
        <Grid item md={10} lg={10}>
            <div style={{padding:'10px',margin:'20px'}}>
                <Typography  className='textTitle' variant='h4' >Counter example using Reactjs</Typography>
                <Divider/>
    
                <Typography className={className}>
                    In this section we will see how to make use of Actumjs to create a simple counter app with Reactjs.
                    <br/>
                    First, we need to create a new Reactjs app.
                    This can be done by using create-react-app.
                </Typography>
                <CodeBase lines={["$ npx create-react-app counter_app"]}/>
                <Typography className={className}>
                After that we need to install Actumjs to our project.
                </Typography>
                <CodeBase
                lines={["$ npm install  @actumjs/actum"]}
                />
                <Typography className={className}>
                Now we will describe our application state as store in src/store/index.js file
                </Typography>
                <CodeBase
     lang='js'
         lines={[
`
    import {createStore} from '@actumjs/actum';
    const initialState = {count:0};
    const store = createStore(initialState);
    export default store;
`
            ]}
         />
      <Typography className={className}>
      To manipulate data within store we need to define actions 
      that modity the store in seperate file  `src\actions\index.js`
     </Typography>
     <CodeBase
     lang='js'
         lines={[
             `
    //an action to increment counter value
    export function increment(payload,state){
        state.count++;
    }
    //an action to decrement counter value
    export function   decrement(payload,state){
        state.count--;
    }`
            ]}
         />
         <Typography className={className}>
            All actions are required to be added into store to update it.
            After adding actions to store our src/store/index.js file will look something like this
         </Typography>
         <CodeBase
     lang='js'
         lines={[`
    import {createStore} from '@actumjs/actum';
    import {increment,decrement} from '../actions
    const initialState = {count:0};
    const store = createStore(initialState);
    //adding actions to store
    store.addAction("increment",increment);
    store.addAction("decrement",decrement);
    export default store;`
           ]}
         />
          <Typography className={className}>
              Now our store is defined and actions are added to it,further we need to create our counter component in ./src/components/CounterComponent.js,
              which will display counter value from store and two buttons to increase and decrease counter value
         </Typography>
         <CodeBase
     lang='js'
         lines={[
             `
    import React from 'react';
    import store from '../store';

    class CounterComponent extends React.Component{
        constructor(props){
            super(props);
        }

    render(){

    let counter = store.getState().count;

    return <div>

        counter : {counter}
        <button>increase</button>
        <button>decrease</button>

    </div>
    }
    }

    export default CounterComponent;
`
            ]}
         />
          <Typography className={className}>
              Inorder to trigger an action we need to handle click events of buttons.
         </Typography>
         <CodeBase
     lang='js'
         lines={[
             `
    import React from 'react';
    import store from '../store';

    class CounterComponent extends React.Component{
        constructor(props){
            super(props);
        }


    render(){

    let counter = store.getState().count;

    return <div>

        counter : {counter}
        <button onClick={()=>{store.trigger("increment");}} >increase</button>
        <button onClick={()=>{store.trigger("decrement");}} >decrease</button>
    </div>
    }
    }

    export default CounterComponent;
`
            ]}
         />
          <Typography className={className}>
            Now we need to reflect changes to component,to do this we need  to listen  actions and update the components.
            This can be done by adding listners to store actions and updating component state whenever listner called.
          </Typography>
         <CodeBase
     lang='js'
         lines={[
             `
    import React from 'react';
    import store from '../store';

    class CounterComponent extends React.Component{

    constructor(props){
            super(props);
            this.state={
                update:false
            }
        this.RemoveIncrementListener=null;
        this.RemoveDecrementListener=null;
    }

    componentDidMount(){
    //add listeners 
    this.RemoveIncrementListener=store.after("increment",this.update);
    this.RemoveDecrementListener=store.after("decrement",this.update);
    }

    componentWillUnmount(){
    //remove all listeners to store
    this.RemoveIncrementListener();
    this.RemoveDecrementListener();
    }



    //this will cause re-render of component
    update=()=>{this.setState({update:(!this.state.update)})}

    render(){

    let counter = store.getState().count;

    return <div>

        counter : {counter}
        <button onClick={()=>{store.trigger("increment");}} >increase</button>
        <button onClick={()=>{store.trigger("decrement");}} >decrease</button>
    </div>
    }
    }

    export default CounterComponent;
`
            ]}
         />
                <Grid container justify='space-between' style={{paddingBottom:'50px'}}>
                    <Grid item >
                        <Link href="/examples">
                            <ArrowLeft/>back to examples
                        </Link>
                    </Grid>

                </Grid>
            </div>
        </Grid>
    </Grid>
    }

    render(){
        let content=null;
        if(window.screen.width<=768){
            content=this.mobileView();
        }else{
            content=this.normalView();
        }
        return <div style={{marginTop:'70px',color:'white',marginBottom:"20px"}}>
            {content}
        </div>; 
    }
}
export default BasicReactExample;